<template>
  <div class="nav">
    <div class="colspan clearfix">
      <div class="clearfix" id="menuListUlContent">
        <div
          v-for="(item,indexs) in navList"
          :key="indexs"
          :class="[ (routerName!=''&&routerName==item.name)||((item.id == navId) && type!=1 &&!routerName) ? 'current nav_li' : '',(item.id != navId && item.activeSelect &&  type!=1) ? 'hover nav_li' : 'nav_li' ]"
          @mouseenter="enter(indexs)"
          @mouseleave="leave(indexs)"
          v-if="!inputShow"
          @click="channelGoto(item)"
        >
          <a :key="'aa'+item.id">
            <span @click="channelGoto(item)">{{item.title}}</span>
          </a>
          <div v-show="item.activeSelect" class="children">
            <a v-for="item1 in item.children" :key="'bb'+item1.id" @click="channelGoto(item1)">
              <p>
                <span>{{item1.title}}</span>
              </p>
            </a>
          </div>
        </div>
        <div
          v-if="$store.state.webInfo.style=='yueyang'&&!inputShow"
          class="searchIcon"
          @click="shadowShow"
        >
          <i class="el-icon-search"></i>
        </div>
        <div
          v-if="$store.state.webInfo.style=='yueyang'&&!inputShow"
          class="btnDonate"
          @click="showQrcode"
        >
          <span>我要捐赠</span>
        </div>
      </div>
      <div class="hide_box" v-if="inputShow">
        <div class="icon_box close" @click="shadowHide">
          <i class="el-icon-close"></i>
        </div>
        <el-input @keyup.enter.native="search" v-model="input" ref="myInput">
          <i slot="suffix" class="el-input__icon el-icon-search font" @click="search"></i>
        </el-input>
      </div>
      <div v-if="$store.state.webInfo.style!='yueyang'" class="button" @click="showQrcode">
        <span>我要捐赠</span>
      </div>
      <div id="showQrcode">
        <div class="qrcodeContent">
          <div class="iconCloseCode">
            <i class="el-icon-close" @click="hideQrcode"></i>
          </div>
          <p>微信扫一扫，进入手机支持</p>
          <div class="codeBox">
            <div id="qrcode"></div>
          </div>
          <div class="thanksInfo">{{pageTitle}}感谢您的支持！</div>
        </div>
      </div>
      <div id="mask" @click="hideQrcode"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import QRCode from "qrcodejs2";
export default {
  props: {
    type: {
      type: Number,
      default: null
    },
    routerName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      navId: "",
      pageTitle: "",
      navList: [
        {
          id: "",
          title: "首页",
          path: "/",
          name: "home",
          activeSelect: false
        }
      ],
      input: "",
      inputShow: false
    };
  },
  methods: {
    shadowShow() {
      this.inputShow = true;
    },
    shadowHide() {
      this.inputShow = false;
      this.input = "";
    },
    enter(index) {
      this.navList[index].activeSelect = true;
    },
    leave(index) {
      this.navList[index].activeSelect = false;
    },
    qrcode() {
      document.getElementById("qrcode").innerHTML = "";
      let url = "";
      if (this.$store.state.webInfo.style == "huarong") {
        url = this.$store.state.webInfo.donation_url;
      } else {
        url =
          this.$store.state.webInfo.donation_url +
          this.$store.state.webInfo.donation_project_id;
      }
      var qrcode = new QRCode("qrcode", {
        text: url,
        width: 256,
        height: 256,
        colorDark: "#000000",
        colorLight: "#ffffff"
      });
    },
    // 我要捐赠 显示二维码
    showQrcode() {
      let qrcode = document.getElementById("showQrcode");
      let mask = document.getElementById("mask");
      this.pageTitle = this.$store.state.webInfo.title;
      qrcode.style.display = "block";
      mask.style.display = "block";
      this.$nextTick(function() {
        this.qrcode();
      });
      // setTimeout(()=>{
      //
      // },0)
      document.documentElement.style.overflow = "hidden";
    },
    // 隐藏二维码
    hideQrcode() {
      let qrcode = document.getElementById("showQrcode");
      let mask = document.getElementById("mask");
      qrcode.style.display = "none";
      mask.style.display = "none";
      document.documentElement.style.overflow = "visible";
    },
    search() {
      this.$router.push({ path: "/search", query: { title: this.input } });
    },
    ...mapActions(["getChannelList"])
  },

  created() {
    let id = this.$route.query.id;
    if (id) {
      this.navId = id;
    }

    this.getChannelList()
      .then(resp => {
        this.navList = this.navList.concat(resp);
      })
      .then(() => {
        if (this.$store.state.webInfo.style == "zhuzhou") {
          let forum = [
            {
              id: null,
              title: "交流论坛",
              path: "/forum",
              name: "forum",
              activeSelect: false
            }
          ];
          this.navList = this.navList.concat(forum);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {},
  watch: {
    "$route.query.id": function(value) {
      this.navId = value;
    },
    inputShow(val) {
      if (val) {
        this.$nextTick(function() {
          this.$refs.myInput.focus();
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.nav {
  width: 100%;
  height: 60px;
  box-shadow: 3px 3px 3px 0px #ccc;
}
.colspan {
  width: 100%;
  min-width: 1200px;
  height: 60px;
  position: relative;

  .searchIcon {
    display: inline-block;
    font-size: 20px;
    color: #fff;
    margin-left: 50px;
    cursor: pointer;
  }
  .hide_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 101;
    .icon_box {
      width: 30px;
      height: 60px;
      line-height: 60px;
      background-color: #3f69b0;
      float: left;
      cursor: pointer;
      > i {
        font-size: 20px;
      }
    }
    /deep/ .el-input {
      width: 500px;
      height: 60px;
      margin: 0 auto;
      /deep/ .el-input__inner {
        height: 60px;
        background-color: #3f69b0;
        outline: none;
        border: 0;
        color: #fff;
      }
    }
  }
}
/deep/ .font {
  font-size: 20px;
  margin-top: 4px;
  color: #fff;
  cursor: pointer;
}
.button {
  float: right;
  height: 50px;
  width: 150px;
  background-color: #fff;
  text-align: center;
  line-height: 50px;
  margin: 5px 140px 5px 0;
  cursor: pointer;
  border-radius: 4px;
  > span {
    font-size: 18px;
  }
}
.btnDonate {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 40px;
  width: 120px;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  border-radius: 4px;
  > span {
    font-size: 16px;
  }
}
#showQrcode {
  position: fixed;
  left: 50%;
  top: 20px;
  z-index: 9999;
  transform: translateX(-50%);
  display: none;
  .qrcodeContent {
    background: #fff;
    padding: 10px 15px 30px 15px;
    border-radius: 5px;
    .iconCloseCode {
      overflow: auto;
      zoom: 1;
      i {
        float: right;
      }
    }
    .codeBox {
      padding-left: 20px;
      padding-right: 20px;
    }
    .thanksInfo {
      text-align: center;
      color: #999;
      margin-top: 20px;
    }
    > p {
      color: #000;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
#qrcode {
  // padding: 20px;
  display: inline-block;
}
#qrcode /deep/ img {
  background-color: #fff; //设置白色背景色
  padding: 12px; // 利用padding的特性，挤出白边
}

.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#menuListUlContent {
  z-index: 100;
  margin: 0;
  padding: 0;
  min-width: 1200px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  line-height: 60px;
  > .nav_li {
    position: relative;
    list-style-type: none;
    float: left;
    min-width: 130px;
    height: 60px;
    line-height: 60px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    > .children {
      width: 180px;
      position: absolute;
      top: 59.99px;
      left: 0;
      z-index: 9999;
      box-shadow: 10px 0px 50px rgba(80, 46, 46, 0.15);
      > a {
        > p {
          margin: 0;
          width: 180px;
          height: 50px;
          line-height: 50px;
          background-color: #fff;
          border-bottom: 1px solid #e5e5e5;
          padding-left: 18px;
          text-align: left;
          > span {
            display: inline-block;
            width: 100%;
            font-size: 16px;
            color: #888;
            // overflow:hidden;
            // text-overflow:ellipsis;
            // white-space: nowrap;
          }
        }
        > p:hover {
          > span {
            color: #fff;
          }
        }
      }
    }
  }
}
#mask {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/Public/nav.vue